module.exports = __webpack_public_path__ + "img/1.ddc22475.jpg";